<script>
import { authComputed } from "@/store/helpers";
import { onMounted, ref } from "vue";
import store from "@/store";
export default {
  computed: {
    ...authComputed,
  },
  name: "DeleteTracer",
  inject: ["GStore"],

  setup() {
    const tracers = ref(null); // Use ref to create a reactive variable
    const fetchData = async () => {
      try {
        tracers.value = await store.dispatch("getTracersAdmin");
      } catch (error) {
        console.error("Error fetching tracers:", error);
      }
    };

    onMounted(fetchData);

    return { tracers, fetchData };
  },

  methods: {
    async deleteTracer(item) {
      // Ask for user confirmation
      if (window.confirm("Are you sure you want to delete this tracer ?")) {
        try {
          await store.dispatch("deleteTracer", {
            id: parseInt(item.id),
          });

          // Refresh tracers data after successful deletion
          this.GStore.flashMessage = "Deleted successfully";

          setTimeout(() => {
            this.GStore.flashMessage = "";
          }, 1500);

        } catch (error) {
          this.GStore.flashMessage = "Something went wrong";
          setTimeout(() => {
            this.GStore.flashMessage = "";
          }, 3000);
        }
      }
    },
  },
};
</script>

<template>
  <div class="container">
    <div class="flashMessage" v-if="GStore.flashMessage">
      {{ GStore.flashMessage }}
    </div>
    <h1 class="vrm-page-title">Delete Tracer</h1>
    <br />

    <p v-if="!tracers" class="sg-color-blue">There are no available tracers</p>
    <div v-else class="row">
      <table class="vrm-table vrm-table--admin">
        <thead>
          <tr>
            <th>ID name</th>
            <th>Tracer name</th>
            <th>Setting 1A</th>
            <th>Setting 1B</th>
            <th>Setting 2A</th>
            <th>Setting 2B</th>
            <th>Setting 3A</th>
            <th>Setting 3B</th>
          </tr>
        </thead>

        <tbody>
          <tr v-for="(item, i) in tracers" :key="i" class="vrm-table__tr--action" @click="deleteTracer(item)">
            <td v-for="(ite, j) in item" :key="j" class="vrm-table__td--icon">
              {{ ite }}
            </td>
          </tr>
        </tbody>
      </table>

      <form @submit.prevent="addTracer"></form>
    </div>
  </div>
</template>

<style scoped lang="less"></style>
